<div class="dialog-header">
  <mat-icon class="dialog-back" (click)="$event.stopPropagation(); tryClose('back')">chevron_left</mat-icon>
  <span class="dialog-title">{{ isEdit ? 'Button bearbeiten' : 'Button hinzufügen' }}</span>
  <mat-icon class="dialog-close" (click)="$event.stopPropagation(); tryClose(null)">close</mat-icon>
</div>
<div class="dialog-body">
  <label class="field-label">Textinhalt des Buttons*</label>
  <input class="field-input" [class.field-error]="form.controls['button_text'].invalid && form.controls['button_text'].touched"
         [formControl]="$any(form.controls['button_text'])" maxlength="500">
  @if (form.controls['button_text'].invalid && form.controls['button_text'].touched) {
    <p class="validation-error">Textinhalt ist ein Pflichtfeld.</p>
  }

  <label class="field-label">Link*</label>
  <input class="field-input" [class.field-error]="form.controls['button_url'].invalid && form.controls['button_url'].touched"
         [formControl]="$any(form.controls['button_url'])" maxlength="500">
  @if (form.controls['button_url'].invalid && form.controls['button_url'].touched) {
    <p class="validation-error">Link ist ein Pflichtfeld.</p>
  }
</div>
<div class="dialog-footer">
  <button class="dialog-save-btn" (click)="save()" [disabled]="form.invalid">Speichern</button>
</div>
